// plop_marker:layouts_import
import FullBackgroundHero from "./full-background-hero/index.js";
export default {
    // plop_marker:layouts_add_layout
    FullBackgroundHero
};
